import { combineReducers, Reducer, AnyAction } from 'redux'
import theme from './theme/themeSlice'
import auth from './auth'
import base from './base'

export interface AsyncReducers {
    [key: string]: Reducer<any, AnyAction>
}

const rootReducer = (asyncReducers?: AsyncReducers) => (state: any, action: AnyAction) => {
    const combinedReducer = combineReducers({
        theme,
        auth,
        base,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
